import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { PatternFormat } from 'react-number-format';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { Input as AntInput } from 'ui/styled';
var regex = /-(.*?)-/;
var phoneFormat = /(\d{1})-(\d{3})-(\d{3})-(\d{4})/;
var Input = function (_a) {
    var disabled = _a.disabled, value = _a.value, _b = _a.errorHandler, errorHandler = _b === void 0 ? function () { } : _b, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, id = _a.id, customInput = _a.customInput, _d = _a.testTitle, testTitle = _d === void 0 ? 'phoneInputString' : _d;
    var setValue = function (number) {
        if (number && number !== 'N/A') {
            if (number.includes('+')) {
                return number.slice(2);
            }
            if (number.match(phoneFormat)) {
                var code = number.match(regex);
                var formattedNumber = number.replace(regex, " (".concat(code[1], ") "));
                return "+".concat(formattedNumber);
            }
            return "+1 ".concat(number);
        }
        return null;
    };
    var _e = useState(setValue(value)), currentValue = _e[0], setCurrentValue = _e[1];
    var onPhoneChange = function (v) {
        var tel = v.target.value || '';
        var error = !isValidPhoneNumber(tel);
        if (errorHandler)
            errorHandler(error);
        setCurrentValue(tel);
        onChange(tel);
    };
    return (_jsx(PatternFormat, { className: "ant-input", format: "+1 (###) ###-####", mask: "_", disabled: disabled, value: currentValue, onChange: onPhoneChange, allowEmptyFormatting: true, "data-test": testTitle, customInput: customInput || AntInput, id: id, autoComplete: "off" }));
};
export default Input;
